/*import { useEffect, useState } from "react";
import api from "../services/api";

export default function RidesPage() {
  const [rides, setRides] = useState([]);

  const fetchRides = async () => {
    try {
      const res = await api.get("/rides");
      setRides(res.data);

    } catch (err) {
      console.log(err.response?.data || err.message);
    }
  };

  useEffect(() => {
    fetchRides();
  }, []);

  const completeRide = async (id) => {
    await api.put(`/rides/complete/${id}`);
    fetchRides();
  };

  const cancelRide = async (id) => {
    await api.put(`/rides/cancel/${id}`);
    fetchRides();
  };

  return (
    <div>
      <h1 style={{ color: "#0B3C5D" }}>
        🚕 Gestion Courses
      </h1>

      <table
        style={{
          width: "100%",
          background: "#fff",
          borderCollapse: "collapse",
          marginTop: 20
        }}
      >
        <thead
          style={{
            background: "#0B3C5D",
            color: "#fff"
          }}
        >
          <tr>
            <th style={th}>ID</th>
            <th style={th}>User</th>
            <th style={th}>Driver</th>
            <th style={th}>Prix</th>
            <th style={th}>Status</th>
            <th style={th}>Actions</th>
          </tr>
        </thead>

        <tbody>
          {rides.map((r) => (
            <tr
              key={r.id}
              style={{
                textAlign: "center",
                borderBottom: "1px solid #eee"
              }}
            >
              <td style={td}>{r.id}</td>
              <td style={td}>{r.user_id}</td>
              <td style={td}>{r.driver_id}</td>
              <td style={td}>{r.price} CFA</td>

              <td style={td}>
                <span
                  style={{
                    padding: "5px 10px",
                    borderRadius: 20,
                    color: "#fff",
                    background:
                      r.status === "completed"
                        ? "green"
                        : r.status === "cancelled"
                        ? "red"
                        : "#FFA500"
                  }}
                >
                  {r.status}
                </span>
              </td>

              <td style={td}>
                <button
                  onClick={() => completeRide(r.id)}
                  style={btnBlue}
                >
                  ✔
                </button>

                <button
                  onClick={() => cancelRide(r.id)}
                  style={btnOrange}
                >
                  ✖
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

const th = {
  padding: 15
};

const td = {
  padding: 15
};

const btnBlue = {
  background: "#0B3C5D",
  color: "#fff",
  border: "none",
  padding: "8px 12px",
  borderRadius: 6,
  marginRight: 5,
  cursor: "pointer"
};

const btnOrange = {
  background: "#FFA500",
  color: "#fff",
  border: "none",
  padding: "8px 12px",
  borderRadius: 6,
  cursor: "pointer"
};
*/



import { useEffect, useState } from "react";
import api from "../services/api";

const PER_PAGE = 8;

export default function RidesPage() {
  const [rides,         setRides]         = useState([]);
  const [filter,        setFilter]        = useState("all");
  const [page,          setPage]          = useState(1);
  const [selectedDriver,setSelectedDriver] = useState(null);

  const fetchRides = () =>
    api.get("/admin/rides").then(res => setRides(res.data)).catch(console.error);

  useEffect(() => { fetchRides(); }, []);

  const completeRide = (id) =>
    api.put(`/admin/rides/complete/${id}`).then(fetchRides);
  const cancelRide = (id) =>
    api.put(`/admin/rides/cancel/${id}`).then(fetchRides);

  const filtered   = filter === "all" ? rides : rides.filter(r => r.status === filter);
  const totalPages = Math.ceil(filtered.length / PER_PAGE);
  const paginated  = filtered.slice((page - 1) * PER_PAGE, page * PER_PAGE);

  const badgeStyle = (status) => ({
    fontSize: 11, padding: "3px 10px", borderRadius: 20, fontWeight: 500,
    background: status === "completed" ? "#EAF3DE" : status === "pending" || status === "searching" ? "#FAEEDA" : status === "started" ? "#E6F1FB" : "#FCEBEB",
    color:      status === "completed" ? "#3B6D11" : status === "pending" || status === "searching" ? "#854F0B" : status === "started" ? "#185FA5" : "#A32D2D",
  });

  const badgeLabel = (s) => ({
    completed: "Terminée", pending: "En attente", searching: "Recherche",
    accepted: "Acceptée", started: "En cours", cancelled: "Annulée",
  }[s] ?? s);

  const summary = [
    { label: "Total",      val: rides.length,                                          color: "#0B3C5D" },
    { label: "Terminées",  val: rides.filter(r => r.status === "completed").length,    color: "#3B6D11" },
    { label: "En attente", val: rides.filter(r => r.status === "searching" || r.status === "pending").length, color: "#854F0B" },
    { label: "Annulées",   val: rides.filter(r => r.status === "cancelled").length,    color: "#A32D2D" },
  ];

  return (
    <div style={{ padding: "1.5rem 0" }}>

      {/* Header */}
      <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: "1.5rem" }}>
        <div>
          <h1 style={{ fontSize: 22, fontWeight: 500, color: "#0B3C5D" }}>🚕 Gestion des courses</h1>
          <p style={{ fontSize: 14, color: "#888", marginTop: 4 }}>Suivi et gestion de toutes les courses</p>
        </div>
        <button onClick={fetchRides} style={{ fontSize: 12, padding: "6px 14px", borderRadius: 20, cursor: "pointer", border: "0.5px solid #ccc", background: "#fff", color: "#888" }}>
          🔄 Actualiser
        </button>
      </div>

      {/* Résumé */}
      <div style={{ display: "grid", gridTemplateColumns: "repeat(4, 1fr)", gap: 10, marginBottom: "1.25rem" }}>
        {summary.map(({ label, val, color }) => (
          <div key={label} style={{ background: "#fff", borderRadius: 8, padding: 12, border: "0.5px solid #e5e5e5" }}>
            <div style={{ fontSize: 11, color: "#888", marginBottom: 4 }}>{label}</div>
            <div style={{ fontSize: 20, fontWeight: 500, color }}>{val}</div>
          </div>
        ))}
      </div>

      {/* Filtres */}
      <div style={{ display: "flex", gap: 8, marginBottom: "1.25rem", flexWrap: "wrap" }}>
        {[["all","Toutes"], ["searching","Recherche"], ["accepted","Acceptées"], ["started","En cours"], ["completed","Terminées"], ["cancelled","Annulées"]].map(([val, label]) => (
          <button key={val} onClick={() => { setFilter(val); setPage(1); }} style={{
            fontSize: 13, padding: "6px 16px", borderRadius: 20, cursor: "pointer",
            border: "0.5px solid #ccc",
            background: filter === val ? "#0B3C5D" : "#fff",
            color: filter === val ? "#fff" : "#888",
          }}>{label}</button>
        ))}
      </div>

      {/* Table */}
      <div style={{ background: "#fff", border: "0.5px solid #e5e5e5", borderRadius: 12, overflow: "hidden" }}>
        <table style={{ width: "100%", borderCollapse: "collapse" }}>
          <thead style={{ background: "#0B3C5D" }}>
            <tr>
              {["ID", "Client", "Chauffeur", "Véhicule", "Prix", "Distance", "Statut", "Date", "Actions"].map(h => (
                <th key={h} style={{ padding: "12px 14px", textAlign: "left", fontSize: 12, fontWeight: 500, color: "#fff" }}>{h}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {paginated.map(r => (
              <tr key={r.id} style={{ borderBottom: "0.5px solid #f0f0f0" }}>

                <td style={{ padding: "12px 14px" }}>
                  <span style={{ fontSize: 11, padding: "2px 8px", borderRadius: 6, background: "#f0f0f0", color: "#888" }}>#{r.id}</span>
                </td>

                {/* Client */}
                <td style={{ padding: "12px 14px" }}>
                  <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                    <div style={{ width: 28, height: 28, borderRadius: "50%", background: "#E6F1FB", color: "#185FA5", fontSize: 11, fontWeight: 600, display: "flex", alignItems: "center", justifyContent: "center" }}>
                      📞
                    </div>
                    <span style={{ fontSize: 13, color: "#0B3C5D" }}>{r.client ?? "—"}</span>
                  </div>
                </td>

                {/* Chauffeur — cliquable */}
                <td style={{ padding: "12px 14px" }}>
                  {r.driver_name ? (
                    <button
                      onClick={() => setSelectedDriver(r)}
                      style={{
                        background: "none", border: "none", cursor: "pointer",
                        display: "flex", alignItems: "center", gap: 8, padding: 0,
                      }}
                    >
                      <div style={{ width: 28, height: 28, borderRadius: "50%", background: "#FAEEDA", color: "#854F0B", fontSize: 11, fontWeight: 600, display: "flex", alignItems: "center", justifyContent: "center" }}>
                        {r.driver_name?.charAt(0).toUpperCase()}
                      </div>
                      <span style={{ fontSize: 13, color: "#0B3C5D", textDecoration: "underline" }}>{r.driver_name}</span>
                    </button>
                  ) : (
                    <span style={{ fontSize: 13, color: "#aaa" }}>—</span>
                  )}
                </td>

                {/* Véhicule */}
                <td style={{ padding: "12px 14px", fontSize: 12, color: "#888" }}>
                  {r.matricule ? (
                    <div>
                      <div style={{ fontWeight: 500, color: "#0B3C5D" }}>{r.matricule}</div>
                      <div style={{ fontSize: 11 }}>{r.vehicle}</div>
                    </div>
                  ) : "—"}
                </td>

                {/* Prix */}
                <td style={{ padding: "12px 14px", fontWeight: 500, color: "#0B3C5D" }}>
                  {r.prix ? `${Number(r.prix).toLocaleString("fr-FR")} CFA` : "—"}
                </td>

                {/* Distance */}
                <td style={{ padding: "12px 14px", fontSize: 13, color: "#888" }}>
                  {r.distance ? `${Number(r.distance).toFixed(1)} km` : "—"}
                </td>

                {/* Statut */}
                <td style={{ padding: "12px 14px" }}>
                  <span style={badgeStyle(r.status)}>{badgeLabel(r.status)}</span>
                </td>

                {/* Date */}
                <td style={{ padding: "12px 14px", fontSize: 12, color: "#aaa" }}>
                  {new Date(r.created_at).toLocaleDateString("fr-FR")}
                </td>

                {/* Actions */}
                <td style={{ padding: "12px 14px" }}>
                  {(r.status === "accepted" || r.status === "started") && (
                    <>
                      <button onClick={() => completeRide(r.id)} style={{ fontSize: 12, padding: "5px 10px", borderRadius: 6, border: "none", background: "#EAF3DE", color: "#3B6D11", cursor: "pointer", marginRight: 6 }}>
                        ✔
                      </button>
                      <button onClick={() => cancelRide(r.id)} style={{ fontSize: 12, padding: "5px 10px", borderRadius: 6, border: "none", background: "#FCEBEB", color: "#A32D2D", cursor: "pointer" }}>
                        ✖
                      </button>
                    </>
                  )}
                  {r.status === "completed" && <span style={{ fontSize: 12, color: "#3B6D11" }}>✅</span>}
                  {r.status === "cancelled"  && <span style={{ fontSize: 12, color: "#A32D2D" }}>⛔</span>}
                </td>

              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* Pagination */}
      <div style={{ display: "flex", gap: 6, marginTop: "1.25rem" }}>
        {Array.from({ length: totalPages }, (_, i) => (
          <button key={i} onClick={() => setPage(i + 1)} style={{
            width: 32, height: 32, borderRadius: 6, cursor: "pointer",
            border: "0.5px solid #ccc",
            background: page === i + 1 ? "#0B3C5D" : "#fff",
            color: page === i + 1 ? "#fff" : "#888",
            fontSize: 13,
          }}>{i + 1}</button>
        ))}
      </div>

      {/* Modal info chauffeur */}
      {selectedDriver && (
        <div onClick={() => setSelectedDriver(null)} style={{
          position: "fixed", inset: 0, background: "rgba(0,0,0,0.5)",
          display: "flex", alignItems: "center", justifyContent: "center", zIndex: 1000,
        }}>
          <div onClick={e => e.stopPropagation()} style={{
            background: "#fff", borderRadius: 16, padding: 24, width: 360,
          }}>
            <div style={{ display: "flex", justifyContent: "space-between", marginBottom: 16 }}>
              <h3 style={{ fontSize: 16, fontWeight: 600, color: "#0B3C5D" }}>Infos Chauffeur</h3>
              <button onClick={() => setSelectedDriver(null)} style={{ background: "none", border: "none", fontSize: 20, cursor: "pointer", color: "#888" }}>✕</button>
            </div>

            {[
              ["👤 Nom",       selectedDriver.driver_name],
              ["📞 Téléphone", selectedDriver.driver_phone],
              ["🚗 Véhicule",  selectedDriver.vehicle],
              ["🔢 Plaque",    selectedDriver.matricule],
              ["💰 Prix course", selectedDriver.prix ? `${Number(selectedDriver.prix).toLocaleString("fr-FR")} CFA` : "—"],
              ["📏 Distance",  selectedDriver.distance ? `${Number(selectedDriver.distance).toFixed(1)} km` : "—"],
            ].map(([label, val]) => (
              <div key={label} style={{ display: "flex", justifyContent: "space-between", padding: "10px 0", borderBottom: "0.5px solid #f0f0f0", fontSize: 13 }}>
                <span style={{ color: "#888" }}>{label}</span>
                <span style={{ fontWeight: 500, color: "#0B3C5D" }}>{val ?? "—"}</span>
              </div>
            ))}
          </div>
        </div>
      )}

    </div>
  );
}